import {
  Organization as OrganizationIcon,
  User as UserIcon,
} from '@energybox/react-ui-library/dist/icons';
import {
  CurrentOrganization,
  CurrentUser,
} from '@energybox/react-ui-library/dist/types';
import {
  TopBar,
  TopBarMenu,
  TopBarMenuItem,
} from '@energybox/react-ui-library/dist/components';

import { useEffect } from 'react';
import { asIcon } from '../../types/icon';
import { connect } from 'react-redux';
import { logout } from '../../actions/app';
import { getCurrentOrganization } from '../../actions/organizations';
import { ApplicationState } from '../../reducers';
import styles from './TopBarContainer.module.css';

const OrganizationIconComponent = asIcon<{
  color?: string;
  size?: number | string;
}>(OrganizationIcon);
const UserIconComponent = asIcon<{
  variant?: string;
  color?: string;
  size?: number | string;
}>(UserIcon);

const ConnectedTopBar = ({
  user,
  logout,
  noNavigation,
  currentOrganization,
  getCurrentOrganization,
}: {
  user?: CurrentUser;
  logout: () => void;
  noNavigation?: boolean;
  currentOrganization?: CurrentOrganization;
  getCurrentOrganization: () => void;
}) => {
  useEffect(() => {
    getCurrentOrganization();
  }, [getCurrentOrganization]);

  if (noNavigation) return <div />;

  return (
    <TopBar>
      <div />
      <div>
        {user && (
          <div className={styles.organizationMenuContainer}>
            <OrganizationIconComponent color="var(--accent-base)" size={14} />
            <span className={styles.organizationMenuTitle}>
              {currentOrganization ? currentOrganization.title : '-'}
            </span>
          </div>
        )}

        <div className={styles.userMenuContainer}>
          <TopBarMenu
            title={user ? `${user.firstName} ${user.lastName}` : '-'}
            icon={
              <UserIconComponent
                variant="tiny"
                color="var(--accent-base)"
                size={16}
              />
            }
          >
            <TopBarMenuItem className={styles.link} onSelect={logout}>
              Logout
            </TopBarMenuItem>
          </TopBarMenu>
        </div>
      </div>
    </TopBar>
  );
};

const mapStateToProps = ({ app, organizations }: ApplicationState) => ({
  user: app.currentUser,
  currentOrganization: organizations.currentOrganization,
});

const mapDispatchToProps = {
  logout,
  getCurrentOrganization,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedTopBar);
